import { render, staticRenderFns } from "./ButtonChartType.vue?vue&type=template&id=5ca2977a&scoped=true&"
import script from "./ButtonChartType.vue?vue&type=script&lang=js&"
export * from "./ButtonChartType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2977a",
  null
  
)

export default component.exports